import { execFile } from 'node:child_process';
import { promisify } from 'node:util';
import { bridgeAgentPathEnv } from '../../acp/clients/bridge-agent-path.js';
import { formatCommandOutput } from '../format-command-output.js';
import type { AgentInstallCommand } from './types.js';

const execFileAsync = promisify(execFile);

export const cursorCliInstallCommand: AgentInstallCommand = {
  agentType: 'cursor-cli',
  detectCommand: 'agent',
  alternateDetectCommands: ['cursor-agent'],
  async install(ctx) {
    const { stdout, stderr } = await execFileAsync(
      'bash',
      ['-lc', 'curl -fsSL https://cursor.com/install | bash'],
      {
        timeout: 300_000,
        env: { ...bridgeAgentPathEnv(ctx.env), CURSOR_API_KEY: ctx.authToken },
        maxBuffer: 10 * 1024 * 1024,
      },
    );
    const logOutput = formatCommandOutput(stdout, stderr);
    ctx.onProgress?.('Installing Cursor CLI', logOutput || undefined);
  },
};
